import { Card } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import { dashboardQueryFactory } from "@/console/apis/dashboard/queryFactory";

interface News {
  title: string;
  link: string;
}

const News = () => {
  const { data: newsList = [] } = dashboardQueryFactory.getNewsList();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!newsList.length) return;

    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % newsList.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [newsList.length]);

  if (!newsList.length) return null;

  return (
    <Card
      title="News"
      style={{ minHeight: 150 }}
      styles={{
        body: {
          padding: "24px",
          overflow: "hidden",
        },
      }}
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="flex items-center"
        >
          <a
            href={newsList[currentIndex].link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-lg hover:underline"
          >
            {newsList[currentIndex].title}
          </a>
        </motion.div>
      </AnimatePresence>
    </Card>
  );
};

export default News;
